import { render, staticRenderFns } from "./_News.vue?vue&type=template&id=e62e3e56&"
import script from "./_News.vue?vue&type=script&lang=ts&"
export * from "./_News.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports